import * as React from "react";
import BiciElectricaContainer from "../containers/seguro-de-bici-electrica-container";

export default function BiciElectricaPage({ data }) {
  return <BiciElectricaContainer data={data}></BiciElectricaContainer>;
}
